/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_DocumentsInputs */

const vi_grower_documents = /** @type {(inputs: Grower_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giấy tờ đính kèm`)
};

/**

* @param {Grower_DocumentsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_documents = /** @type {((inputs?: Grower_DocumentsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_DocumentsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_documents(inputs)
});